import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, ViewEncapsulation, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { ConfigurationState } from '@cbcore/NGRX/configuration/configuration.models';
import { AppState, selectConfiguration, track } from '@cbcore/NGRX/core.state';
import { Config } from "@cbcore/services/config/config.service";
import { WindowService } from "@cbcore/services/utils/window/window.service";
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { isEqual } from "lodash-es";
import { WidgetTopCaptainsListComponent } from '../top-captains-list/top-captains-list';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';

@Component({
    selector: 'widget-top-captains',
    templateUrl: './top-captains.html',
    encapsulation: ViewEncapsulation.None, // .widget-items .list-item targets child component WidgetTopCaptainsListComponent template
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PipesModule, TranslocoModule, WidgetTopCaptainsListComponent]
})
export class WidgetTopCaptainsComponent implements OnInit {
  @Input() data?: any;
  @Output() clicked: EventEmitter<void> = new EventEmitter();

  public imagesUrl!: string; // Assigned unconditionally in ngOnInit — pre-existing assumption, not independently verified
  public displayState: any;
  public _window: any;
  public region!: string; // Assigned unconditionally in ngOnInit — pre-existing assumption, not independently verified
  public date = new Date();
  public view: string | null = null;

  private configuration$!: Observable<ConfigurationState>; // Assigned unconditionally in ngOnInit — pre-existing assumption, not independently verified
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private _router: Router,
    private _config: Config,
    public windowRef: WindowService,
    private store: Store<AppState>
  ) {
    this._window = windowRef.nativeWindow;
  }

  ngOnInit(): void {
    this.imagesUrl = this._config.CONFIG.imagesUrl;
    this.region = this._config.CONFIG.widgetRegion;

    this.configuration$ = this.store.select(selectConfiguration);
    this.configuration$.pipe(
      distinctUntilChanged((prev, curr) => isEqual(prev, curr)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(configuration => {
      try {
        this.displayState = configuration.displayState;
        const rawView = this.displayState?.view;
        // Because regex aint gonna crash if data incorrect
        this.view =
          typeof rawView === 'string'
            ? rawView.replace(/_/g, '-').toLowerCase()
            : 'all';
      } catch(error) {
        console.error(error);
      }
    });
  }

  openLink(url: string[]): void {
    this.clicked.emit();
    this.trackBannerClicks();
    this._router.navigate(url);
  }

  trackBannerClicks(): void {
    const trackingObject = {
      'event': 'micrositeEvent',
      'eventCategory': 'RHW_Banner',
      'eventAction': 'Click',
      'eventLabel': this.displayState.view
    }

    this.store.dispatch(track({event: trackingObject}));
  }
}
